var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnUpload = function SvgIcnUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0186 5.9323C10.8525 5.9323 10.6865 5.87113 10.5554 5.74006L8.39704 3.58168L6.23865 5.74006C5.98523 5.99347 5.56579 5.99347 5.31238 5.74006C5.05896 5.48664 5.05896 5.0672 5.31238 4.81379L7.9339 2.19226C8.18732 1.93884 8.60676 1.93884 8.86017 2.19226L11.4817 4.81379C11.7351 5.0672 11.7351 5.48664 11.4817 5.74006C11.3506 5.87113 11.1846 5.9323 11.0186 5.9323Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39708 10.3015C8.03881 10.3015 7.7417 10.0044 7.7417 9.64612V2.65538C7.7417 2.29711 8.03881 2 8.39708 2C8.75536 2 9.05246 2.29711 9.05246 2.65538V9.64612C9.05246 10.0131 8.75536 10.3015 8.39708 10.3015Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39712 13.8969C6.55331 13.8969 4.70076 13.5998 2.94433 13.0143C2.60353 12.9007 2.42003 12.525 2.53363 12.1842C2.64723 11.8434 3.02299 11.6511 3.36379 11.7735C6.61448 12.857 10.1885 12.857 13.4392 11.7735C13.78 11.6599 14.1557 11.8434 14.2693 12.1842C14.3829 12.525 14.1994 12.9007 13.8586 13.0143C12.0935 13.6085 10.2409 13.8969 8.39712 13.8969Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_upload.a7cacae9.svg";
export { ForwardRef as ReactComponent };